import React from 'react';
import './ShoeProduction.css';
import ServicesNav from './ServicesNav';
import shoe2 from '../../assets/shoe2.jpg'
const ShoeProduction = () => {
  return (
    <div className="shoe-production-page">
      <ServicesNav />
      <div className="shoe-content">
        <h1 className="title">Shoe Production</h1>
        <p className="description">
          Our shoe production services create high-quality footwear through eco-friendly production practices.
        </p>
        <img src={shoe2} alt="Shoe Production" className="shoe-image" />
      </div>
    </div>
  );
};

export default ShoeProduction;
